module.exports = __webpack_public_path__ + "static/media/tooth.25f411eb.svg";